import { z } from 'zod';
/** Esquemas de decisión del núcleo (spec §6.1). Las opciones salen en tiempo de ejecución de los catálogos del tenant. */
export const DecisionSchemaCode = {
    TASK_INTAKE: 'TASK_INTAKE_V1',
    ALIGNMENT: 'ALIGNMENT_V1',
    EVIDENCE: 'EVIDENCE_V1',
    RISK_CLASSIFICATION: 'RISK_CLASSIFICATION_V1',
    DUE_RISK: 'DUE_RISK_V1',
    PROJECT_HEALTH: 'PROJECT_HEALTH_V1',
    COMMITMENT: 'COMMITMENT_V1',
    SPECIALTY: 'SPECIALTY_V1',
};
export const DECISION_SCHEMA_LABEL = {
    TASK_INTAKE_V1: 'Triaje de solicitudes entrantes',
    ALIGNMENT_V1: 'Alineación con objetivos y entregables',
    EVIDENCE_V1: 'Suficiencia de la evidencia',
    RISK_CLASSIFICATION_V1: 'Clasificación de riesgos y hallazgos',
    DUE_RISK_V1: 'Riesgo de vencimiento (experimental)',
    PROJECT_HEALTH_V1: 'Salud del proyecto',
    COMMITMENT_V1: 'Compromisos en actas',
    SPECIALTY_V1: 'Especialidad requerida',
};
/** Modo del motor por tenant (spec §6.4). */
export const EngineMode = { JEV: 'JEV', LAYA_ONLY: 'LAYA_ONLY', DISABLED: 'DISABLED' };
export const ENGINE_MODE_LABEL = { JEV: 'Datalog Decision Engine (servicio externo de TypeSafe)', LAYA_ONLY: 'Solo LAYA (local, nada sale del servidor)', DISABLED: 'Desactivado' };
export const decisionConfigSchema = z.object({
    schemaCode: z.nativeEnum(DecisionSchemaCode),
    enabled: z.boolean(),
    thresholds: z.object({ automatic: z.number().min(0.5).max(1), reviewRecommended: z.number().min(0).max(1) }).refine((t) => t.reviewRecommended <= t.automatic, 'El umbral de revisión no puede superar el automático'),
    timeoutMs: z.number().int().min(1000).max(120_000).default(30_000),
});
export const engineModeSchema = z.object({ mode: z.nativeEnum(EngineMode) });
export const decisionReviewSchema = z.object({
    action: z.enum(['CONFIRM', 'OVERRIDE', 'DISMISS']),
    /** Para OVERRIDE: campo → valor nuevo. */
    values: z.record(z.string(), z.unknown()).optional(),
    reasonCode: z.enum(['INCORRECT', 'ADDITIONAL_INFO', 'ORG_RULE', 'OTHER']).optional(),
    comment: z.string().max(2000).optional(),
});
//# sourceMappingURL=decisions.js.map